import Booking from '@models/Booking'

export const createBooking = (data) => {
  return Booking.create(data)
}
